import { KdfType } from "../../enums/kdfType";

import { BaseResponse } from "./base.response";

export class PreloginResponse extends BaseResponse {
  kdf: KdfType;
  kdfIterations: number;
  twoFactorProviders: Record<string, object>;

  constructor(response: any) {
    super(response);
    this.kdf = this.getResponseProperty("Kdf");
    this.kdfIterations = this.getResponseProperty("KdfIterations");
    this.twoFactorProviders = this.getResponseProperty("TwoFactorProviders2");
  }
}
